export const regEx = new RegExp(/<\*(.*?)\*>/g);
